import { List } from 'immutable';
import { tFunctionType } from 'app/services/localization';
import EnumClass, { build } from '../EnumClass';
import data, { StaffPositionId, StaffPositionData } from './data';
import * as Translations from './translations';
import { getAbilityById, Ability, isAbilityId } from '../Ability';

export class StaffPosition extends EnumClass<StaffPositionId, StaffPositionData> {
  public get getName() {
    return Translations.name[this.id];
  }

  public getDescription = (t: tFunctionType) => {
    const abilities = this.abilities
      .map((ability) => ability.getName(t))
      .join(t('list-separator'));
    return t('enum.staff-position.description', { abilities });
  };

  public get managedBy() {
    return getAbilityById(this.metadata.managed_by);
  }

  public get abilities() {
    return List<Ability>((this.metadata.abilities as unknown[]).map((abilityId: unknown) => {
      if (isAbilityId(abilityId)) {
        return getAbilityById(abilityId);
      } else {
        throw new Error(`Could not parse ${abilityId} as Ability Id`);
      }
    }));
  }
}

export const {
  list: STAFF_POSITIONS,
  getById: getStaffPositionById,
  marshaller: StaffPositionMarshaller,
} = build<StaffPositionId, StaffPositionData, StaffPosition>('StaffPositionEnum', data, StaffPosition);
